import script from "./ExcursionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExcursionForm.vue?vue&type=script&setup=true&lang=ts"

import "./ExcursionForm.vue?vue&type=style&index=0&id=c9ff8aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9ff8aea"]])

export default __exports__